export default __webpack_public_path__ + "static/media/Wedding-illustration1.179e257d.svg";